import Markdown from "react-markdown";
import { ChatMessageType } from "../../../types/chatWidget";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

// @ts-ignore
import "katex/dist/katex.min.css";

export default function ChatMessage({
  message,
  isSend,
  error,
  sender_name,
  isAgent,
  agent_name,
  user_message_style,
  bot_message_style,
  error_message_style,
}: ChatMessageType) {

  // Human-agent messages get a distinctive badge and left-accent border
  const displayName = isAgent
    ? (agent_name || sender_name || "Agent")
    : sender_name;

  return (
    <div
      className={
        "cl-chat-message " + (isSend ? " cl-justify-end" : " cl-justify-start")
      }
    >
      {isSend ? (
        <div style={user_message_style} className="cl-user_message">
          {message}
        </div>
      ) : error ? (
        <div style={error_message_style} className={"cl-error_message"}>
          {message}
        </div>
      ) : (
        <div className="flex flex-col items-start max-w-[85%]">
          {/* Sender label: agent name (human) or bot name */}
          {!isSend && displayName && displayName !== "Machine" && (
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: "11px",
              marginBottom: "4px",
              marginLeft: isAgent ? "2px" : "4px",
              color: isAgent ? "#2563eb" : "#6b7280",
              fontWeight: 600,
            }}>
              {isAgent && (
                <span style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  background: "#2563eb",
                  color: "#fff",
                  fontSize: 9,
                  flexShrink: 0,
                }}>
                  {/* Person icon (inline SVG so no extra dep) */}
                  <svg viewBox="0 0 16 16" fill="currentColor" width={10} height={10}>
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5 5a5 5 0 0 1 10 0H3Z" />
                  </svg>
                </span>
              )}
              {displayName}
            </div>
          )}
          <div
            style={{
              ...(isAgent
                ? {
                  borderLeft: "3px solid #2563eb",
                  paddingLeft: 10,
                  background: "#eff6ff",
                  borderRadius: "0 12px 12px 0",
                }
                : {}),
              ...bot_message_style,
            }}
            className={"cl-bot_message"}
          >
            <div className={"markdown-body prose flex flex-col word-break-break-word"}>
              <Markdown
                remarkPlugins={[remarkGfm, remarkMath]}
                rehypePlugins={[rehypeKatex]}
              >
                {message}
              </Markdown>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
